import Swiper, { Navigation, FreeMode, Mousewheel } from 'swiper';

function init() {
    const info = document.querySelector('.js-info-swiper');
    if (info) {
        const prev = document.querySelector('.js-info-swiper-prev');
        const next = document.querySelector('.js-info-swiper-next');
        if (prev && next) {
            let swiper = new Swiper(info, {
                modules: [Navigation, FreeMode, Mousewheel],
                slidesPerView: 'auto',
                freeMode: true,
                mousewheel: true,
                navigation: {
                    prevEl: prev,
                    nextEl: next,
                },
            });
        }
    }

    const key = document.querySelector('.js-key-swiper');
    if (key) {
        let swiper = new Swiper(key, {
            modules: [FreeMode, Mousewheel],
            slidesPerView: 'auto',
            freeMode: true,
            mousewheel: true,
        });
    }

    const projects = document.querySelector('.js-projects-swiper');
    if (projects) {
        let swiper = new Swiper(projects, {
            modules: [FreeMode, Mousewheel],
            slidesPerView: 'auto',
            freeMode: true,
            mousewheel: true,
        });
    }

    const tarifs = document.querySelectorAll('.js-tarifs-swiper');
    if (tarifs.length > 0) {
        tarifs.forEach((element) => {
            let swiper = new Swiper(element, {
                modules: [FreeMode, Mousewheel],
                direction: 'horizontal',
                slidesPerView: 'auto',
                freeMode: true,
                mousewheel: true,
            });
        });
    }

    const reviews = document.querySelector('.js-reviews-swiper');
    if (reviews) {
        const prev = document.querySelector('.js-reviews-swiper-prev');
        const next = document.querySelector('.js-reviews-swiper-next');

        let swiper = new Swiper(reviews, {
            modules: [Navigation],
            slidesPerView: 1,
            loop: true,
            spaceBetween: 10,
            navigation: {
                prevEl: prev,
                nextEl: next,
            },
        });
    }
}

export default { init };
